import { jsxs as _jsxs } from "react/jsx-runtime";
import { formatTimeString } from '@repo/date-time';
export default function PackageTimeDisplay({ parkingPackage, testId }) {
    return (_jsxs("span", { "data-testid": testId.append('time'), children: [formatTimeString(parkingPackage.startAt), " - ", formatTimeString(parkingPackage.endAt)] }));
}
